import React, { useEffect, useState } from "react";
import Header from "../Main/Header";
import Table from "../../components/shared/table";
import styles from './main.module.css';

import { connect, useDispatch, useSelector } from "react-redux";
import {
  Api_Get_Aboutus_AGW,
  Api_Get_Addressbook_list_AGW,
  Api_get_balance_AGW,
  Api_get_Order_Info_AGW,
  Api_Get_Services_AGW,
  Api_Get_Support_Message_AGW,
  Api_Get_Web_Setting_AGW,
} from "../../helper/api/ApiGateway";
import { setupSocket } from "../../socket/Setup_socket";
import { faviconUpdate } from "../../helper/module";
import loading from "../../../src/static/loading.gif";
import BulkImport from "../BulkImport";
import Menu from "../Main/Menu";
import { initTable } from "../../Redux/reducers/table";
import { ChangeViewTravelDialoge, Set_Table_ActiveOrderType, Table_Init } from "../../Redux/actions/actionNames";
import _ from 'lodash';
import TableList from "../../components/shared/table";
import { getTableDefaultColumn } from "../../components/shared/table/action/getTableDefaultColumn";
import AboutUs from "../Main/AboutUs";
import OrderHistory from "../Main/OrderHistory";
import TableFilter from "../../components/table/filter";
import TransactionsList from "../Main/TransactionsList";
import MessagesBoxlist from "../Main/MessagesBoxlist";
import Settings from "../Main/Settings";
import Support from "../Main/Support";
import TableNoOrder from "../../components/table/table-noOrder";
import TableError from "../../components/table/table-error";
import TableNoOrderFilter from "../../components/table/table-noOrder-filter";
import TableSelectedOrders from "../../components/table/selectedOrders";
import NewOrder from "../Main/NewOrder";
import OrderList from "../Main/OrderList";
import Map from "../Main/Map";
import EditStatusSummary from "../../components/table/EditStatusSummary";
import ViewOrder from "../Main/ViewOrder";
import { useTranslation } from "react-i18next";


// class App extends React.Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       loaded: false ,
//       windowLoaded : false
//     };
//     this.handleLoad = this.handleLoad.bind(this)

//   }

//   handleLoad() {
//     this.setState({
//       windowLoaded: true
//     })
//   }

//   componentDidMount() {
//     document.addEventListener('applicationMap', (detail)=>{
//       // console.log("applicationMap",detail.detail.applicationMap )
//       this.setState({
//         loaded: true
//       })
//     } )
//     // window.addEventListener("load", this.handleLoad);

//     faviconUpdate()
//     Api_Get_Web_Setting_AGW(dispatch, null, null)
//     Api_Get_Aboutus_AGW(dispatch, {}, (call) => { });
//     Api_get_balance_AGW(dispatch, {}, (call) => { });
//     Api_Get_Addressbook_list_AGW(dispatch, { page: 1, perpage: 10, searchRegex: "" }, false);
//     setupSocket(dispatch);
//     Api_Get_Support_Message_AGW(dispatch)

//     document.addEventListener('visibilitychange', function (ev) {
//     });


//     window.onfocus = () => {
//       Api_get_balance_AGW(dispatch, {}, (call) => { });
//     };

//   }
//   render() {
//     return (
//       <div className="MainContainer">
//         {/* <DevelopmentCenterControlPanel /> */}

//         {(!this.state.loaded ) &&

//           <div style={{ backgroundColor: "white", width: '100vw', height: "100vh", position: "absolute", left: "0", top: "0", zIndex: "500" }}>
//             <img style={{ width: "110px", marginLeft: "calc(50% - 55px)", float: "left", marginTop: "calc(50vh - 100px)" }} src={loading} />
//           </div>
//         }
//         {this.state.loaded  &&

//           <React.Fragment>
//             {/* <Table /> */}
//             <Menu />
//             <Header />
//             {/* <AboutUs /> */}
//             {/* <OrderHistory /> */}
//             {/* <OrderList /> */}
//             {/* <TransactionsList /> */}
//             {/* <MessagesBoxlist /> */}
//             {/* <Settings /> */}
//             {/* <Support /> */}
//             {/* <NewOrder /> */}
//             {/* <ViewOrder /> */}
//             {/* <Map /> */}
//           </React.Fragment>
//         }

//         {this.props.IsOpen && <BulkImport />}

//       </div>
//     );
//   }
// }

// const mapStateToProps = (state) => ({
//   IsOpen : state.BulkImport.IsOpen
// });
// const mapDispatchToProps = (dispatch) => ({
//   dispatch: dispatch,
// });

// export default connect(mapStateToProps, mapDispatchToProps)(App);


function TableOrders(props) {
  const selectedOrders = useSelector((state) => state.Table.selectedOrders)
  const TableisLoading = useSelector((state) => state.Table.isLoading)
  const TablehasError = useSelector((state) => state.Table.hasError)
  const TableListData = useSelector((state) => state.Table.list.orders)
  const IsOpen = useSelector((state) => state.BulkImport.IsOpen)
  const type = useSelector((state) => state.Table.filters.type)
  const selectedBulkEditStatusSummary = useSelector((state) => state.Table.selectedBulkEditStatusSummary)
  const socket = useSelector((state) => state.Socket.socket)

  
  const hasNextPage = useSelector((state) => state.Table.list.hasNextPage)
  const hasPreviousPage = useSelector((state) => state.Table.list.hasPreviousPage)
  const totalCount = useSelector((state) => state.Table.list.totalCount)
  const perPage = useSelector((state) => state.Table.perPage)
  const page = useSelector((state) => state.Table.page)
  const table = useSelector((state) => state.Table.tableInit)
  const tableFilters = useSelector((state) => state.Table.filters)
  const OpenDialogeViewTravel = useSelector((state) => state.ViewTravel.OpenDialoge)
  const WebSettings = useSelector((state) => state.SharedData.WebSettings)

  const [loaded, setLoaded] = useState(false);
  const [isViewOrder, setIsViewOrder] = useState(true);
  const mainLoaded = useSelector((state) => state.SharedData.mainLoaded)
  const dispatch = useDispatch();
  const [tableLayoutUsedHeight, setTableLayoutUsedHeight] = useState(0)
  const { t, i18n } = useTranslation();


  useEffect(() => {
    dispatch(Set_Table_ActiveOrderType("PickupDelivery"))
    if (!socket) {
      faviconUpdate()
      Api_Get_Web_Setting_AGW(dispatch, null, null)
      Api_Get_Aboutus_AGW(dispatch, {}, (call) => { });
      Api_get_balance_AGW(dispatch, {}, (call) => { });
      Api_Get_Addressbook_list_AGW(dispatch, { page: 1, perpage: 10, searchRegex: "" }, false);
      //setupSocket(dispatch);
      Api_Get_Support_Message_AGW(dispatch)


      document.addEventListener('applicationMap', (detail) => {
        setLoaded(true)
      })
      return () => {
        document.removeEventListener('applicationMap', (detail) => {
          setLoaded(true)
        })
      };
    }else{
      setLoaded(true)
    }

  }, [WebSettings]);



  // useEffect(() => {
  //     if (String(location.pathname).length == 7) {
  //         setIsViewOrder(false)
  //         dispatch(ResetViewTravel());
  //         UpdateOrdersStatistics()
  //     } else {
  //         setIsViewOrder(true)
  //     }

  // }, [location]);


  useEffect(() => {
    dispatch(Set_Table_ActiveOrderType("PickupDelivery"))
    // if (String(location.pathname).length < 4) {
    //     history.replace('/orders');
    // }



  }, [])


  const InitTable = (REF) => {
    dispatch(Table_Init(REF))

  }


  const canClearAll = React.useCallback(() => {
    let DEFf = JSON.parse(JSON.stringify(initTable.filters))
    delete DEFf.type
    let NEWf = JSON.parse(JSON.stringify(tableFilters))
    delete NEWf.type


    return !_.isEqual(DEFf, NEWf)
  }, [tableFilters]);


  const openViewOrder = React.useCallback((orderId) => {
   // Api_get_balance_AGW(dispatch, {}, (call) => { });

    dispatch(ChangeViewTravelDialoge(true, orderId));
    Api_get_Order_Info_AGW(dispatch, orderId);
    // this.props.dispatch(OrderInfoAction(this.props.dispatch,{
    //   orderId : this.props.id
    // }))
    Api_Get_Services_AGW(dispatch, null);
  }, []);




  if (loaded || WebSettings) {

    return <div
      className={styles.App}
    >
      {IsOpen && <BulkImport />}
      {selectedBulkEditStatusSummary && <EditStatusSummary />}

      <div className={styles.innerApp}>
        <Menu />
        <Header style={{ position: "unset", boxShadow: type == "Ondemand" ? "0 0 4px 0 rgba(128, 128, 128, 0.3)" : "unset" }} />
        <AboutUs />
        <OrderHistory />
        <TransactionsList />
        <MessagesBoxlist />
        <Settings />
        <Support />
        {/* <NewOrder />
        <ViewOrder /> */}

        {/* {(type == "Ondemand" || OpenDialogeViewTravel) ? <>  <OrderList /> </> : <>
          <TableFilter heightOnChange={setTableLayoutUsedHeight} />
          {(!TablehasError && (TableListData?.length >= 0 || !TableListData)) && <>
            <TableSelectedOrders />
            <TableList TablehasError={TablehasError} canClearAll={canClearAll} selectedOrders={selectedOrders} data={TableListData} hasNextPage={hasNextPage} hasPreviousPage={hasPreviousPage} totalCount={totalCount}
              perPage={perPage} page={page} TableisLoading={TableisLoading} conatinerWidth={"100%"} conatinerHeight={`calc(100vh - ${Object.keys(selectedOrders).length > 0 ? "102" : tableLayoutUsedHeight}px)`}
              tableColumns={getTableDefaultColumn(openViewOrder)} table={table} initTableRef={InitTable}
            />

          </>}

          {(TablehasError && !TableisLoading) && <div className={styles.innerApp}>
            <TableError />
          </div>}

          {(!TablehasError && !canClearAll() && (TableListData && TableListData.length == 0 && !TableisLoading)) && <div className={styles.innerApp}>
            <TableNoOrder />
          </div>}

          {(!TablehasError && canClearAll() && (TableListData && TableListData.length == 0) && !TableisLoading) && <div className={styles.innerApp}>
            <TableNoOrderFilter />
          </div>}

        </>} */}

          <TableFilter heightOnChange={setTableLayoutUsedHeight} />
          {(!TablehasError && (TableListData?.length >= 0 || !TableListData)) && <>
            <TableSelectedOrders />
            <TableList TablehasError={TablehasError} canClearAll={canClearAll} selectedOrders={selectedOrders} data={TableListData} hasNextPage={hasNextPage} hasPreviousPage={hasPreviousPage} totalCount={totalCount}
              perPage={perPage} page={page} TableisLoading={TableisLoading} conatinerWidth={"100%"} conatinerHeight={`calc(100vh - ${Object.keys(selectedOrders).length > 0 ? "102" : tableLayoutUsedHeight}px)`}
              tableColumns={getTableDefaultColumn(openViewOrder , t)} table={table} initTableRef={InitTable}
            />

          </>}

          {(TablehasError && !TableisLoading) && <div className={styles.innerApp}>
            <TableError />
          </div>}

          {(!TablehasError && !canClearAll() && (TableListData && TableListData.length == 0 && !TableisLoading)) && <div className={styles.innerApp}>
            <TableNoOrder />
          </div>}

          {(!TablehasError && canClearAll() && (TableListData && TableListData.length == 0) && !TableisLoading) && <div className={styles.innerApp}>
            <TableNoOrderFilter />
          </div>}


        {/* <Map /> */}

        {/* <Navbar isViewOrder={isViewOrder || Object.keys(selectedOrders).length > 0} /> */}



      </div>


    </div>
  } else {
    return <div style={{ backgroundColor: "white", width: '100vw', height: "100vh", position: "absolute", left: "0", top: "0", zIndex: "500" }}>
      <img style={{ width: "110px", marginLeft: "calc(50% - 55px)", float: "left", marginTop: "calc(50vh - 100px)" }} src={loading} />
    </div>


  }


}


export default TableOrders